import React from 'react';
import styled, { css } from 'styled-components';
import { IAppBarNavItem } from './AppBar.models';
import { OnlineThemeType } from '../../themes/online';
import classNames from 'classnames';
import Locked from '../../assets/locked.svg';

export interface INavigationSmallProps {
  className?: string;
  navItems: Array<IAppBarNavItem>;
  activeItem: string;
  onNavItemClick: (name: string) => void;
}

export interface INavigationSmallPropsWithTheme extends INavigationSmallProps {
  theme: OnlineThemeType;
}

const StyledNavigationSmall = ({ theme }: INavigationSmallPropsWithTheme) => {
  return css`
    display: flex;

    > .item {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      min-width: 110px;
      height: 40px;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      background: #fff;
      line-height: 21px;
      color: ${theme.colors.placeholder2};
      cursor: pointer;

      &.disabled {
        cursor: not-allowed;
      }

      &.is-active {
        border-bottom: 3px solid ${theme.colors.primaryBright};
        color: ${theme.colors.primaryBright};

        img {
          filter: invert(70%) sepia(96%) saturate(7463%) hue-rotate(226deg) brightness(99%) contrast(105%); //primaryBright
        }
      }
    }
  `;
};

export const NavigationSmall = styled((props: INavigationSmallProps) => {
  const onItemClicked = (name: string, disabled: boolean) => {
    if (disabled) return;
    props.onNavItemClick(name);
  };

  return (
    <div className={props.className}>
      {props.navItems.map((item) => (
        <div
          key={item.name}
          className={classNames('item', {
            'is-active': item.name === props.activeItem && !item.disabled,
            disabled: item.disabled,
          })}
          onClick={() => onItemClicked(item.name, item.disabled)}
          data-at={`appbar-nav-item-${item.name}`}
        >
          <img src={item.disabled ? Locked : item.svgIconSmallSrc} />
          {item.title}
        </div>
      ))}
    </div>
  );
})`
  ${StyledNavigationSmall}
`;
